module.exports = __webpack_public_path__ + "static/media/01_4.f61decfb.png";